import { IComponentOptions } from "angular";
import { MachineDetailConfigurationsComponentController } from "./controller";

export const vsName = "machineDetailConfigurationsComponent";

export const machineDetailConfigurationsComponentOptions: IComponentOptions = {
  controller: MachineDetailConfigurationsComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
    progressiveDefinitions: "<",
    reportGroup: "<",
  },
};
